module.exports = __webpack_public_path__ + "static/media/icon_search.90832165.png";